/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Button, Modal, Paper, Stack, Typography } from '@mui/material';
import FarmlandsLogoColored from '../assets/images/FarmlandsProLogoColored.svg';
import useMsalFunctions from '../util/useMsalAuthFunctions';
import TestIds from '../testIds';

const CELinkNoAccess: FC = (): JSX.Element => {
  const { handleCEMsalLogout } = useMsalFunctions();

  return (
    <Modal open={true}>
      <Paper>
        <Stack
          data-testid={TestIds.pages.ceLinkNoAccess}
          gap={2}
          alignItems='center'
          height='100vh'
        >
          <Stack direction='column' gap={2} maxWidth={'600px'} paddingTop={7}>
            <img
              src={FarmlandsLogoColored}
              alt='Farmlands PRO'
              style={{
                height: '25px',
                alignSelf: 'flex-start',
              }}
            />
            <Typography variant='h1'>UNABLE TO ACCESS THIS ACCOUNT</Typography>
            <Typography variant='body1'>
              We’re unable to open this account from CE Link right now.
            </Typography>
            <Typography variant='body1'>
              Please close this tab and try again using CE Link or by logging in to FarmlandsPRO
              directly. If the issue continues, contact your administrator or the Service Desk for
              assistance.
            </Typography>
            <Button
              data-testid={TestIds.feat.ceLinkNoAccess.logoutButton}
              variant='outlined'
              onClick={() => handleCEMsalLogout()}
              sx={{ width: '250px' }}
            >
              Close tab
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
};

export default CELinkNoAccess;
